var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.19c0 .35.28.62.62.62h2.5c.57 0 1.04-.47 1.04-1.04v-2.5c0-.35-.28-.62-.62-.62s-.62.28-.62.62v1.09a7.589 7.589 0 0 0-3.51-2.59c-1.93-.7-4.03-.61-5.89.26a7.655 7.655 0 0 0-3.99 4.35c-1.45 3.99.61 8.43 4.61 9.88.87.32 1.75.46 2.63.46 3.15 0 6.11-1.94 7.25-5.07a.626.626 0 0 0-.37-.8.626.626 0 0 0-.8.37 6.463 6.463 0 0 1-8.28 3.86 6.463 6.463 0 0 1-.52-11.93 6.37 6.37 0 0 1 4.94-.21c1.36.5 2.49 1.41 3.25 2.62h-1.6c-.35 0-.62.28-.62.62Z",
    fill: "current"
  })));
};
export default SvgRefresh;